import { IStackStyles } from "@fluentui/react";

export const containerStyles: IStackStyles = {
	root: {
		background: 'linear-gradient(to left, #0085ba, #9b5c8f)',
		color: '#ffffff',
		height: '100vh',
		padding: 0
	},
}